import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

/** **************************************
 * Firebase
 *************************************** */
const Firebase = {
  SignInPage: lazy(() => import('src/pages/auth/sign-in')),
  VerifyPage: lazy(() => import('src/pages/auth/verify')),
  ResetPasswordPage: lazy(() => import('src/pages/auth/reset-password')),
};
// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'sign-in',
        element: (
          <GuestGuard>
            <AuthSplitLayout
              slotProps={{
                section: {
                  title: 'Tutto Matto!',
                  subtitle: 'Welcome back to Matto Espresso Admin',
                },
              }}
            >
              <Firebase.SignInPage />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'verify',
        element: (
          <AuthSplitLayout>
            <Firebase.VerifyPage />
          </AuthSplitLayout>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <AuthSplitLayout>
            <Firebase.ResetPasswordPage />
          </AuthSplitLayout>
        ),
      },
    ],
  },
];
